import React from 'react'
import { default as MuiRadio } from '@material-ui/core/Radio'
import type { RadioProps as MuiRadioProps } from '@material-ui/core/Radio'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses } from '../../styles'

const useStyles = makeStyles<Theme, RadioProps>({
  root: {}
})

export interface RadioProps extends MuiRadioProps {
  classes?: MuiRadioProps['classes'] & StyleClasses<typeof useStyles>
}

function Radio(props: RadioProps) {
  const classes = useStyles(props)

  return <MuiRadio color="primary" {...props} classes={classes} />
}

export default Radio
